'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactGa = require('react-ga');
var _reactGa2 = _interopRequireDefault(_reactGa);
var _loadGa = require('../Ga/loadGa');
var _loadGa2 = _interopRequireDefault(_loadGa);
var _Logo = require('../Logo');
var _Logo2 = _interopRequireDefault(_Logo);
var _hamburger = require('@cimpress/react-components/lib/shapes/hamburger');
var _Icon = require('@cimpress/react-components/lib/Icon');
var _Icon2 = _interopRequireDefault(_Icon);
var _Profile = require('../Profile');
var _Profile2 = _interopRequireDefault(_Profile);
var _SideNav = require('./SideNav');
var _SideNav2 = _interopRequireDefault(_SideNav);
var _reactSmoothCollapse = require('react-smooth-collapse');
var _reactSmoothCollapse2 = _interopRequireDefault(_reactSmoothCollapse);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Header = function (_Component) {
  _inherits(Header, _Component);
  function Header(props) {
    _classCallCheck(this, Header);
    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
    (0, _loadGa2.default)();
    _this.state = {
      sideNavOpen: false,
      requiredSpace: -1,
      mobileNavOpen: false,
      forceMobile: false,
      gaUserSet: false
    };
    _this.toggleSideNav = _this.toggleSideNav.bind(_this);
    _this.setRef = _this.setRef.bind(_this);
    _this.toggleMobileNav = _this.toggleMobileNav.bind(_this);
    _this.calculateResponsive = _this.calculateResponsive.bind(_this);
    _this.updateRequiredSpace = _this.updateRequiredSpace.bind(_this);
    return _this;
  }
  _createClass(Header, [{
    key: 'toggleSideNav',
    value: function toggleSideNav() {
      this.setState({
        sideNavOpen: !this.state.sideNavOpen
      });
    }
  }, {
    key: 'toggleMobileNav',
    value: function toggleMobileNav() {
      this.setState({
        mobileNavOpen: !this.state.mobileNavOpen
      });
    }
  }, {
    key: 'setRef',
    value: function setRef(el) {
      if (el) this[el.attributes['data-ref'].value] = el;
    }
  }, {
    key: 'calculateResponsive',
    value: function calculateResponsive() {
      if (this.state.mobileNavOpen) this.setState({
        mobileNavOpen: false
      });
      var styles = window.getComputedStyle(this.fluidNav);
      var padding = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);
      var forceMobile = this.fluidNav.clientWidth - padding <= this.state.requiredSpace;
      if (this.state.forceMobile !== forceMobile) this.setState({
        forceMobile: forceMobile
      });
    }
  }, {
    key: 'updateRequiredSpace',
    value: function updateRequiredSpace() {
      var fluidNavTabs = this.fluidNavTabs;
      var fluidNavTitle = this.fluidNavTitle;
      if (!this.state.mobileNavOpen && fluidNavTitle && fluidNavTitle.offsetWidth && fluidNavTabs && fluidNavTabs.offsetWidth) {
        var requiredSpace = fluidNavTabs.offsetWidth + fluidNavTitle.offsetWidth;
        if (this.state.requiredSpace < requiredSpace) this.setState({
          requiredSpace: requiredSpace
        }, this.calculateResponsive);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _reactGa2.default.ga('create', 'UA-65356408-11', 'auto', 'PlatformTracker');
      if (this.props.profile && this.props.profile.sub) {
        _reactGa2.default.ga('PlatformTracker.set', 'userId', this.props.profile.sub);
        this.setState({
          gaUserSet: true
        });
      }
      _reactGa2.default.ga('PlatformTracker.send', 'pageview', window.location.pathname);
      if (this.props.responsive) {
        this.updateRequiredSpace();
        window.addEventListener('resize', this.calculateResponsive);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.responsive && !this.state.mobileNavOpen) {
        this.updateRequiredSpace();
      }
      if (this.props.profile && this.props.profile.sub && (prevProps.profile && prevProps.profile.sub) !== (this.props.profile && this.props.profile.sub) && !this.state.gaUserSet) {
        _reactGa2.default.ga('PlatformTracker.set', 'userId', this.props.profile.sub);
        _reactGa2.default.ga('PlatformTracker.send', 'event', 'User', 'logged in after page load');
        this.setState({
          gaUserSet: true
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.calculateResponsive);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      var _props = this.props,
        appTitle = _props.appTitle,
        appLinks = _props.appLinks,
        onSettingsClicked = _props.onSettingsClicked,
        notifications = _props.notifications,
        documentationUrl = _props.documentationUrl,
        mailToAddress = _props.mailToAddress,
        accessToken = _props.accessToken;
      var mobileNavOpen = this.state.forceMobile && this.state.mobileNavOpen;
      var navLinks = _react2.default.createElement('ul', {
        onMouseDown: function onMouseDown(e) {
          return _this2.state.mobileNavOpen ? e.preventDefault() : undefined;
        },
        className: 'nav nav-tabs ' + (this.state.forceMobile ? 'nav-stacked' : ''),
        style: this.state.forceMobile ? {
          paddingBottom: 10
        } : {},
        ref: this.setRef,
        'data-ref': 'fluidNavTabs'
      }, appLinks.map(function (link, i) {
        return _react2.default.createElement('li', {
          key: i
        }, link);
      }), onSettingsClicked || documentationUrl || mailToAddress ? _react2.default.createElement('li', {
        className: 'link-divider'
      }) : null, onSettingsClicked ? _react2.default.createElement('li', {
        className: 'icon-link',
        key: 'settings-link'
      }, _react2.default.createElement('a', {
        onClick: onSettingsClicked,
        className: 'clickable'
      }, _react2.default.createElement(_Icon2.default, {
        name: 'cog-f'
      }))) : null, documentationUrl ? _react2.default.createElement('li', {
        className: 'icon-link',
        key: 'documentation-link'
      }, _react2.default.createElement('a', {
        'aria-label': 'Documentation',
        href: documentationUrl,
        className: 'clickable'
      }, _react2.default.createElement(_Icon2.default, {
        name: 'book-open-4-f'
      }))) : null, mailToAddress ? _react2.default.createElement('li', {
        className: 'icon-link',
        key: 'mailto-link'
      }, _react2.default.createElement('a', {
        'aria-label': 'Contact Email',
        href: 'mailto:' + mailToAddress,
        className: 'clickable'
      }, _react2.default.createElement(_Icon2.default, {
        name: 'email-2-f'
      }))) : null);
      var showNav = this.props.showLeftNav;
      var fluidNav = _react2.default.createElement('div', {
        className: 'navbar-fluid ' + (this.state.requiredSpace || this.props.appLinks.length === 0 ? '' : 'sizer')
      }, _react2.default.createElement('nav', {
        className: 'navbar navbar-block subtitle',
        ref: this.setRef,
        'data-ref': 'fluidNav'
      }, _react2.default.createElement('div', {
        className: 'navbar-header',
        ref: this.setRef,
        'data-ref': 'fluidNavTitle'
      }, _react2.default.createElement('span', {
        className: 'navbar-toggle clickable',
        onClick: this.toggleMobileNav,
        style: this.state.forceMobile ? {
          outline: 'none',
          paddingBottom: 10
        } : {},
        tabIndex: '2',
        onBlur: function onBlur() {
          return _this2.setState({
            mobileNavOpen: false
          });
        }
      }, 'Menu ', _react2.default.createElement('span', {
        className: 'caret'
      })), _react2.default.createElement('h2', null, appTitle), _react2.default.createElement(_reactSmoothCollapse2.default, {
        expanded: mobileNavOpen
      }, navLinks)), _react2.default.createElement('div', {
        className: 'fluid-collapse navbar-fluid-collapse navbar-right'
      }, navLinks)));
      return _react2.default.createElement('div', null, showNav ? _react2.default.createElement(_SideNav2.default, {
        sideNavOpen: this.state.sideNavOpen,
        toggleSideNav: this.toggleSideNav,
        language: this.props.language,
        environment: this.props.environment,
        activeNavLinkId: this.props.appId,
        accessToken: accessToken
      }) : null, _react2.default.createElement('nav', {
        className: 'navbar navbar-default'
      }, showNav ? _react2.default.createElement('span', {
        className: 'hamburger',
        onClick: this.toggleSideNav
      }, _react2.default.createElement(_hamburger.Hamburger, null)) : null, _react2.default.createElement('div', {
        className: 'navbar-brand',
        style: !showNav ? {
          marginLeft: '0px'
        } : {}
      }, _react2.default.createElement(_Logo2.default, {
        width: '107px'
      })), notifications, _react2.default.createElement('div', {
        className: 'dropdown mcp-navbar-userbox'
      }, _react2.default.createElement(_Profile2.default, this.props))), this.state.forceMobile ? _react2.default.createElement('div', {
        className: 'forceMobile',
        children: fluidNav
      }) : fluidNav);
    }
  }]);
  return Header;
}(_react.Component);
exports.default = Header;
Header.propTypes = {
  appTitle: _propTypes2.default.node.isRequired,
  appLinks: _propTypes2.default.arrayOf(_propTypes2.default.node),
  notifications: _propTypes2.default.node,
  documentation: _propTypes2.default.node,
  mailTo: _propTypes2.default.node,
  appId: _propTypes2.default.string,
  showLeftNav: _propTypes2.default.bool,
  language: _propTypes2.default.string,
  environment: _propTypes2.default.string,
  responsive: _propTypes2.default.bool,
  profile: _propTypes2.default.shape({
    email: _propTypes2.default.string,
    name: _propTypes2.default.string,
    picture: _propTypes2.default.string,
    domain: _propTypes2.default.string,
    sub: _propTypes2.default.string
  }),
  tenantSelectorProps: _propTypes2.default.shape({
    tenantType: _propTypes2.default.string,
    onTenantSelected: _propTypes2.default.func,
    initialTenantType: _propTypes2.default.oneOf(['merchant', 'fulfiller']),
    initialTenantId: _propTypes2.default.string,
    show: _propTypes2.default.bool
  }),
  onSettingsClicked: _propTypes2.default.func,
  onLogOutClicked: _propTypes2.default.func.isRequired,
  onLogInClicked: _propTypes2.default.func.isRequired,
  isLoggedIn: _propTypes2.default.bool,
  accessToken: _propTypes2.default.string
};
Header.defaultProps = {
  appLinks: [],
  showLeftNav: true,
  responsive: false,
  language: 'en',
  environment: 'prd'
};